<template>
  <v-container fluid class="calendar-page h-100">
    <div class="row h-100">
      <div class="col-md-8">
        <div class="d-flex mb-2 align-items-center">
          <div class="font-weight-medium text-h2">
            {{ dayjs(today).format("MMMM YYYY") }}
          </div>
          <div class="ml-auto">
            <v-btn elevation="1" @click.stop="setRangeDate('prev')" fab small class="mr-2" color="white">
              <v-icon>
                mdi-arrow-left-thick
              </v-icon>
            </v-btn>
            <v-btn elevation="1" @click.stop="setRangeDate('next')" fab small class="mr-2" color="white">
              <v-icon>
                mdi-arrow-right-thick
              </v-icon>
            </v-btn>
          </div>
        </div>
        <CalendarView
          :startingDayOfWeek="1"
          :selectionStart="selectedDate"
          :showDate="today"
          :items="items"
          @click-date="setDate($event)"
        >
          <CalendarViewHeader> </CalendarViewHeader>
        </CalendarView>
      </div>
      <div class="col-md-4">
        <div>
          <div class="font-weight-medium text-h3 mb-2">
            <span class=" mr-1 text-uppercase">{{ dayjs(selectedDate).format("dddd") }}</span>
            <span class="text--disabled">
              {{ dayjs(selectedDate).format("D MMMM YYYY") }}
            </span>
          </div>
          <!-- <FormInput name="addTask" :value="input.value" :error="input.error" :placeholder="input.placeholder" class="mb-6"></FormInput> -->
          <div class="flex flex-col gap-4">
            <v-btn small class="mb-2" @click="open(ev)" v-for="ev in displayEvents" :key="ev.id">
              {{ dayjs(ev.startDate).format("HH:mm") }} - {{ ev.title }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import dayjs from "dayjs";

export default {
  name: "Calendar",
  components: { CalendarView, CalendarViewHeader },
  data: () => ({
    items: [],
    dayjs,
    today: new Date(),
    selectedDate: new Date(),
  }),
  computed: {
    displayEvents() {
      const filtered = this.items.filter(item => {
        return dayjs(item.startDate).format("MM.DD") === dayjs(this.selectedDate).format("MM.DD");
      });
      return filtered.sort(function(a, b) {
        const keyA = dayjs(a.startDate),
          keyB = dayjs(b.startDate);
        // Compare the 2 dates
        if (keyA.isBefore(keyB)) return -1;
        if (keyA.isAfter(keyB)) return 1;
        return 0;
      });
    },
  },
  methods: {
    open(ev) {
      const newPath = `/ikp?customer_id=${ev.customer_id}&doctor_id=${this.$store.state.auth.id}`;
      const domain = window.location.origin;
      window.open(domain + newPath, "_blank").focus();
    },
    setRangeDate(type) {
      if (type === "prev") {
        this.today = dayjs(this.today)
          .subtract(1, "month")
          .toISOString();
      }
      if (type === "next") {
        this.today = dayjs(this.today)
          .add(1, "month")
          .toISOString();
      }
    },
    setDate(date) {
      this.selectedDate = date;
    },
  },
  async created() {
    const { data } = await this.$http.get(`/v1/doctor/appointments`);

    if (data && data.data.length) {
      this.items = data.data.map(el => {
        const result = {
          id: el.id,
          customer_id: el.customer.id,
          startDate: dayjs(el.start_at, "DD.MM.YYYY HH:mm").toDate(),
          title: `Консультация, ${el.customer.full_name}`,
        };
        return result;
      });
    }
  },
};
</script>

<style lang="scss">
.calendar-page {
  &__day {
    width: calc(100% / 7);
    &-number {
      .calendar-page__day--current & {
        color: theme("colors.action");
      }
      .calendar-page__day--selected & {
        background: #313538;
        color: #fff;
      }
    }
  }

  .cv-wrapper {
    .cv-header-days {
      background: rgba(23, 30, 38, 0.04);
      border-color: transparent;
    }
    .cv-header-day {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      color: #7e8794;
      border-color: transparent;
    }
    .cv-week {
      height: 94px;
      flex-basis: 94px;
    }
    .cv-day {
      cursor: pointer;
      border-color: #171e2614;
      &:hover {
        background: rgba(23, 30, 38, 0.04);
      }
      &.outsideOfMonth {
        color: #7e8794;
      }
      &.today {
        border: 1px solid #313538;
      }
      &.selectionStart {
        background: #313538;
        color: #fff;
      }
    }
    .cv-day-number {
      margin-left: auto;
      font-size: 12px;
      margin-left: auto;
    }
    .cv-item {
      background-color: #2196f3 !important;
      border-color: #2196f3 !important;
      color: #fff !important;
      border-radius: 4px;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      pointer-events: none;
    }
  }
}
</style>
